// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BjOnT5Nsz3TyZJ2DpJxJ{display:grid;grid-template-columns:268px 1fr;min-height:378px}.TSuQUBbvGM1MHrCpIgF9{padding:0 24px 18px}`, "",{"version":3,"sources":["webpack://./src/widgets/SavedReplies/ui/SavedRepliesContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,+BAAA,CACA,gBAAA,CAGF,sBACE,mBAAA","sourcesContent":[".content{\n  display: grid;\n  grid-template-columns: 268px 1fr;\n  min-height: 378px;\n}\n\n.alerts {\n  padding: 0 24px 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `BjOnT5Nsz3TyZJ2DpJxJ`,
	"alerts": `TSuQUBbvGM1MHrCpIgF9`
};
export default ___CSS_LOADER_EXPORT___;
